import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";
import { FieldWrapper } from "styles/formStyleComponents";

const uiFont = appThemeFonts.family.ui;

export const SectionBlock = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

export const SectionHeading = styled(Typography)({
  fontFamily: uiFont,
  fontWeight: 600,
  fontSize: "12px",
  color: appThemeColors.text.primary,
  margin: 0,
  lineHeight: 1.3,
});

export const InstructionText = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "12.5px",
  fontWeight: 400,
  color: appThemeColors.text.muted,
  margin: 0,
  lineHeight: 1.5,
});

export const ErrorText = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "12.5px",
  fontWeight: 500,
  color: appThemeColors.semantic.danger,
  margin: 0,
  lineHeight: 1.4,
});

export const DetailsReadOnlyStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

export const ReadOnlyFieldRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
  minWidth: 0,
  minHeight: 38,
  padding: "8px 12px",
  backgroundColor: appThemeColors.background.fill,
  border: `1px solid ${appThemeColors.border.default}`,
  borderRadius: appThemeRadius.md,
});

export const ReadOnlyFieldMain = styled(Box)({
  minWidth: 0,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: 2,
});

export const ReadOnlyFieldLabel = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "11px",
  fontWeight: 600,
  letterSpacing: "0.04em",
  color: appThemeColors.text.faint,
  lineHeight: 1.2,
});

export const ReadOnlyFieldValue = styled(Typography)({
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  fontFamily: uiFont,
  fontSize: "13.5px",
  fontWeight: 400,
  color: appThemeColors.text.primary,
  lineHeight: 1.35,
});

export const ReadOnlyFieldCopyButton = styled(Box)({
  flexShrink: 0,
});

export const FieldsStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 15,
  "& > *": {
    marginBottom: "0 !important",
  },
  [`& ${FieldWrapper}`]: {
    marginBottom: 0,
  },
});
